// WARNING it is used pretty much every where on orga home, project home, side bar and header
// Update with caution
import { documentationLink } from '@/shared/Config'

export default [
  {
    category: 'analytics',
    color: '#00CCF9',
    services: [
      {
        id: 'dm',
        serviceId: 'dm',
        image: require('@/core/components/Dataplant/assets/dm.svg'),
        imageDisabled: require('@/core/components/Dataplant/assets/dm_grey.svg'),
        displayName: 'services.display_name.dm',
        smallDescription: 'services.small_description.dm',
        longDescription: 'services.long_description.dm',
        documentation: `${documentationLink('/landing-page-lakehouse-manager')}`,
        hidden: true
      },
      {
        id: 'connectors',
        serviceId: 'connectors',
        image: require('@/core/components/Dataplant/assets/connectors.svg'),
        imageDisabled: require('@/core/components/Dataplant/assets/connectors_grey.svg'),
        displayName: 'services.display_name.connectors',
        smallDescription: 'services.small_description.connectors',
        longDescription: 'services.long_description.connectors',
        documentation: `${documentationLink('/landing-page-connectors')}`
      },
      {
        id: 'lakehouse',
        serviceId: 'lakehouse',
        image: require('@/core/components/Dataplant/assets/lakehouse.svg'),
        imageDisabled: require('@/core/components/Dataplant/assets/lakehouse_grey.svg'),
        displayName: 'services.display_name.lakehouse',
        smallDescription: 'services.small_description.lakehouse',
        longDescription: 'services.long_description.lakehouse',
        documentation: `${documentationLink('/landing-page-lakehouse-manager')}`
      },
      {
        id: 'dpe',
        serviceId: 'dpe',
        image: require('@/core/components/Dataplant/assets/dpe.svg'),
        imageDisabled: require('@/core/components/Dataplant/assets/dpe_grey.svg'),
        displayName: 'services.display_name.dpe',
        smallDescription: 'services.small_description.dpe',
        longDescription: 'services.long_description.dpe',
        documentation: `${documentationLink('/landing-page-dpe')}`
      },
      {
        id: 'am',
        serviceId: 'am',
        image: require('@/core/components/Dataplant/assets/am.svg'),
        imageDisabled: require('@/core/components/Dataplant/assets/am_grey.svg'),
        displayName: 'services.display_name.am',
        smallDescription: 'services.small_description.am',
        longDescription: 'services.long_description.am',
        documentation: `${documentationLink('/landing-page-analytics-manager')}`
      }
    ]
  }, {
    category: 'artificial-intelligence',
    color: '#9EDF10',
    services: [
      {
        id: 'mlm',
        serviceId: 'mlm',
        image: require('@/core/components/Dataplant/assets/ml.svg'),
        imageDisabled: require('@/core/components/Dataplant/assets/ml_grey.svg'),
        displayName: 'services.display_name.mlm',
        smallDescription: 'services.small_description.mlm',
        longDescription: 'services.long_description.mlm',
        documentation: `${documentationLink('/landing-page-data-platform')}`,
        dataplatform: false
      },
      {
        id: 'notebooks',
        serviceId: 'notebooks',
        image: require('@/core/components/Dataplant/assets/ml.svg'),
        imageDisabled: require('@/core/components/Dataplant/assets/ml_grey.svg'),
        displayName: 'services.display_name.notebooks',
        smallDescription: 'services.small_description.notebooks',
        longDescription: 'services.long_description.notebooks',
        documentation: `${documentationLink('/landing-page-data-platform')}`,
        hidden: true
      }
    ]
  }, {
    category: 'application-services',
    color: '#FFCD2F',
    services: [
      {
        id: 'apps',
        serviceId: 'appservice',
        image: require('@/core/components/Dataplant/assets/app.svg'),
        imageDisabled: require('@/core/components/Dataplant/assets/app_grey.svg'),
        displayName: 'services.display_name.apps',
        smallDescription: 'services.small_description.apps',
        longDescription: 'services.long_description.apps',
        documentation: `${documentationLink('/landing-page-app-services-apps')}`
      },
      {
        id: 'app',
        serviceId: 'appservice',
        image: require('@/core/components/Dataplant/assets/app.svg'),
        imageDisabled: require('@/core/components/Dataplant/assets/app_grey.svg'),
        displayName: 'services.display_name.app',
        smallDescription: 'services.small_description.app',
        longDescription: 'services.long_description.app',
        documentation: `${documentationLink('/landing-page-app-services-apps')}`,
        hidden: true
      },
      {
        id: 'superset',
        serviceId: 'appservice',
        image: require('@/core/components/Dataplant/assets/superset.svg'),
        imageDisabled: require('@/core/components/Dataplant/assets/superset_grey.svg'),
        displayName: 'services.display_name.superset',
        smallDescription: 'services.small_description.superset',
        longDescription: 'services.long_description.superset',
        documentation: `${documentationLink('/tutorials-install-apache-superset')}`,
        hidden: true
      },
      {
        id: 'api',
        serviceId: 'appservice',
        image: require('@/core/components/Dataplant/assets/api.svg'),
        imageDisabled: require('@/core/components/Dataplant/assets/api_grey.svg'),
        displayName: 'services.display_name.api',
        smallDescription: 'services.small_description.api',
        longDescription: 'services.long_description.api',
        documentation: `${documentationLink('/landing-page-app-services-apis')}`,
        hidden: true
      },
      {
        id: 'functions',
        serviceId: 'functions',
        image: require('@/core/components/Dataplant/assets/app.svg'),
        displayName: 'services.display_name.functions',
        smallDescription: 'services.small_description.functions',
        longDescription: 'services.long_description.functions',
        documentation: '',
        hidden: true
      },
      {
        id: 'workflow-manager',
        serviceId: 'workflow-manager',
        image: require('@/core/components/Dataplant/assets/api.svg'),
        displayName: 'services.display_name.workflow_manager',
        smallDescription: 'services.small_description.workflow_manager',
        longDescription: 'services.long_description.workflow_manager',
        documentation: '',
        hidden: true
      }
    ]
  }, {
    category: 'admin-tools',
    color: '#F62172',
    services: [
      {
        id: 'billing-explorer',
        serviceId: 'billing-explorer',
        image: require('@/core/components/Dataplant/assets/plan.svg'),
        displayName: 'services.display_name.billing_explorer',
        smallDescription: 'services.small_description.billing_explorer',
        longDescription: 'services.long_description.billing_explorer',
        documentation: `${documentationLink('/manage-pricing')}`,
        fromOrganization: true,
        legacy: true
      },
      {
        id: 'storage-engines',
        serviceId: 'storage-engines',
        image: require('@/core/components/Dataplant/assets/storage-engines.svg'),
        displayName: 'services.display_name.storage_engines',
        smallDescription: 'services.small_description.storage_engines',
        longDescription: 'services.long_description.storage_engines',
        documentation: `${documentationLink('/landing-page-data-platform')}`,
        fromOrganization: true
      },
      {
        id: 'control-center',
        serviceId: 'control-center',
        image: require('@/core/components/Dataplant/assets/cc.svg'),
        imageDisabled: require('@/core/components/Dataplant/assets/cc_grey.svg'),
        displayName: 'services.display_name.control-center',
        smallDescription: 'services.small_description.control_center',
        longDescription: 'services.long_description.control_center',
        documentation: `${documentationLink('/landing-page-control-center')}`
      },
      {
        id: 'iam',
        serviceId: 'iam',
        image: require('@/core/components/Dataplant/assets/iam.svg'),
        imageDisabled: require('@/core/components/Dataplant/assets/iam_grey.svg'),
        displayName: 'services.display_name.iam',
        smallDescription: 'services.small_description.iam',
        longDescription: 'services.long_description.iam',
        documentation: `${documentationLink('/landing-page-iam')}`
      }
    ]
  }
]
